import { render, staticRenderFns } from "./biAnalysis.vue?vue&type=template&id=5dfda2d7&scoped=true&"
import script from "./biAnalysis.vue?vue&type=script&lang=js&"
export * from "./biAnalysis.vue?vue&type=script&lang=js&"
import style0 from "./biAnalysis.vue?vue&type=style&index=0&id=5dfda2d7&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dfda2d7",
  null
  
)

export default component.exports